<template>
  <v-table
    :count="count"
    :list="list"
    :query-list="queryList"
    :is-show-store-select="isHeadOffice"
    :is-store-select-clearable="true"
    :is-loading="isLoading"
    :is-show-search-input="true"
    :push-list="RouteConfig.courseColumnList.push"
    search-placeholder="输入名称进行搜索"
  >
    <v-column-time/>
    <v-column-time v-if="isHeadOffice" value="修改时间" field="update_time" sortable=""/>
    <v-column-time value="预约开始时间" field="start_time" sortable=""/>
    <v-column-time value="预约结束时间" field="end_time" sortable=""/>
    <el-table-column v-if="isHeadOffice" label="所属门店" prop="store_name"/>
    <el-table-column label="专栏名称" prop="course_column_name"/>
    <el-table-column label="专栏封面" width="200">
      <template v-slot="{ row }">
        <v-img class="table-cover-video" :value="row.cover"/>
      </template>
    </el-table-column>
    <el-table-column label="扣卡次数" align="center">
      <template v-slot="{ row }">
        <span>{{ row.decrement_number | toYuan }}</span>
      </template>
    </el-table-column>
    <el-table-column label="通卡扣卡天数" align="center">
      <template v-slot="{ row }">
        <span>{{ row.decrement_days | toYuan }}</span>
      </template>
    </el-table-column>

    <el-table-column label="预约上限" prop="student_number" align="center"/>
    <el-table-column label="已约人数" prop="student_count" align="center"/>

    <el-table-column label="操作" width="310px">
      <template v-slot="{ row }">

        <v-list-button
          name="小程序码"
          icon="mini-app-qr-code"
          size="large"
          @click="getQrCode(row.id)"
          :is-loading="isGetting[row.id]"
        />

        <v-list-button name="修改专栏" size="large" :to="RouteConfig.courseColumnEdit.to(row.id)"/>

        <v-popover>
          <v-popover-item icon="reserve-manage" name="预约管理" :to="RouteConfig.courseColumnManage.to(row.id)"/>
          <v-popover-item
            icon="bin"
            name="删除专栏"
            @click="handleDelete(row.id)"
            :is-loading="isDeleting[row.id]"
            message="删除专栏后，已预约的学员需要手动帮其取消预约，确认要删除该专栏吗？"
          />
        </v-popover>
      </template>
    </el-table-column>

    <template slot="mobile-list">
      <section class="list">
        <template v-if="list.length">
          <div
            v-for="(v, k) in list"
            :key="`card-ticket-list-${k}-${v.id}`"
            class="list-item primary-background-light"
          >
            <div class="list-item-detail">
              <span>添加时间</span>
              <span>{{ v.add_time | timeToYmdHi }}</span>
            </div>

            <div v-if="isHeadOffice" class="list-item-detail">
              <span>修改时间</span>
              <span>{{ v.update_time | timeToYmdHi }}</span>
            </div>

            <div class="list-item-detail">
              <span>预约开始时间</span>
              <span>{{ v.start_time | timeToYmdHi }}</span>
            </div>

            <div class="list-item-detail">
              <span>预约结束时间</span>
              <span>{{ v.end_time | timeToYmdHi }}</span>
            </div>

            <div class="list-item-detail">
              <span>所属门店</span>
              <span>{{ v.store_name }}</span>
            </div>

            <div class="list-item-detail">
              <span class="flex-shrink">专栏名称</span>
              <span class="list-item-info">{{ v.course_column_name }}</span>
            </div>

            <div class="list-item-detail">
              <span>专栏封面</span>
              <v-img class="table-cover-video" :value="v.cover"/>
            </div>

            <div class="list-item-detail">
              <span>扣卡次数</span>
              <span>{{ v.decrement_number | toYuan }}</span>
            </div>

            <div class="list-item-detail">
              <span>通卡扣卡天数</span>
              <span>{{ v.decrement_days | toYuan }}</span>
            </div>

            <div class="list-item-detail">
              <span>预约上限</span>
              <span>{{ v.student_number }}</span>
            </div>

            <div class="list-item-detail">
              <span>已约人数</span>
              <span>{{ v.student_count }}</span>
            </div>

            <div class="list-item-button">
              <v-list-button
                name="小程序码"
                icon="mini-app-qr-code"
                size="large"
                @click="getQrCode(v.id)"
                :is-loading="isGetting[v.id]"
              />

              <v-list-button name="修改专栏" size="large" :to="RouteConfig.courseColumnEdit.to(v.id)"/>

              <v-popover>
                <v-popover-item icon="reserve-manage" name="预约管理" :to="RouteConfig.courseColumnManage.to(v.id)"/>
                <v-popover-item
                  icon="bin"
                  name="删除专栏"
                  @click="handleDelete(v.id)"
                  :is-loading="isDeleting[v.id]"
                  message="删除专栏后，已预约的学员需要手动帮其取消预约，确认要删除该专栏吗？"
                />
              </v-popover>
            </div>
          </div>
        </template>

        <v-empty :is-loading="isLoading" :length="list.length"/>
      </section>
    </template>
  </v-table>
</template>

<script>
  import RouteConfig from '@/router/config';
  import { mapGetters } from 'vuex';
  import getQrCode from './getQrCode';
  import { index, destroy } from '@/api/course-column';
  import { getLegalQueryList } from "@/utils/formats";

  export default {
    name: RouteConfig.courseColumnList.name,
    data: () => ({
      RouteConfig,
      count: 0,
      list: [],
      queryList: {
        store_id: '',
        keyword: '',
        is_asc: 0,
        page: 1,
        size: 10,
      },
      isLoading: false,
      isGetting: {},
      isDeleting: {},
    }),
    computed: {
      ...mapGetters([
        'isHeadOffice',
      ]),
    },
    watch: {
      '$route'(to) {
        this.load(to);
      },
    },
    beforeMount() {
      this.load();
    },
    methods: {
      async load(route = this.$route, next) {
        const { queryList } = this;
        getLegalQueryList(queryList, route.query);

        this.isLoading = true;
        const { isError, data } = await index(queryList);
        this.isLoading = false;
        if (isError) return;

        this.count = data.count;
        this.list = data.list;
        if (next) next();
      },
      async handleDelete(id) {
        if (!id) return this.$message.warning('缺少专栏 ID，无法删除该专栏！');
        if (this.isDeleting[id]) return;

        this.$set(this.isDeleting, id, true);
        const { isError } = await destroy(id);
        this.$set(this.isDeleting, id, false);

        if (!isError) this.load();
      },
      getQrCode,
    },
  };
</script>
